import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthorizedGuard  {

  constructor(private router: Router, private authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

      return this.authService.isAuthorized(true).pipe(
        map(authorized => {
          if (!authorized) {
            this.authService.redirectUrl = state.url;
            this.router.navigate(['/login']);
            return false;
          }
          return true;
        })
      );
  }
  
}
